import { OperationError, OperationErrorData } from './operation-error';

export const getErrorMessage = (error: unknown): string | undefined => {
  const typedError = error as OperationError;
  return typedError.data && typeof typedError.data !== 'string'
    ? (typedError.data as OperationErrorData).error_title
    : (typedError.data as string);
};
